import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/(protected)/admin/(content)/emergency-broadcast": [7],
		"/admin/feedbacks/[id]": [9],
		"/(protected)/admin/(content)/ml-scanner": [8],
		"/ai-workflow": [10],
		"/alerts": [11],
		"/alerts/[id]": [12,[],[2]],
		"/analytics/energy-forecast": [13],
		"/approved-alerts": [14],
		"/dashboard": [15],
		"/dashboard/admin": [16],
		"/feedback": [17],
		"/field-operations/field-tech-portal": [18],
		"/field-operations/field-tech-portal/[work_order_id]/dashboard": [19],
		"/field-tech": [20,[3]],
		"/field-tech/alerts": [21,[3]],
		"/field-tech/profile": [22,[3]],
		"/field-tech/session/[id]": [23,[3]],
		"/field-tech/tracking": [24,[3]],
		"/field-tech/work-orders": [25,[3]],
		"/field-tech/work-orders/[id]": [26,[3]],
		"/login": [27],
		"/logs": [28],
		"/ml-predictions": [29],
		"/my-feedback": [30],
		"/my-feedback/[id]": [31],
		"/password-reset": [32],
		"/profile": [33],
		"/reset-password": [~34],
		"/technician": [35,[4]],
		"/technician/alerts": [36,[4]],
		"/technician/session/[id]": [37,[4]],
		"/technician/settings": [38,[4]],
		"/technician/shifts": [39,[4]],
		"/technician/tracking": [40,[4]],
		"/technician/work-orders": [41,[4]],
		"/technician/work-orders/[id]": [42,[4]],
		"/work-orders": [43],
		"/work-orders/[id]": [44,[],[5]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';